/* eslint-disable import/first */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useLocation } from '@reach/router';
import { Button } from '@material-ui/core';
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
import css from './index.module.scss';
import noImg from './noAddress.svg';
const NoAddress = ({ action }) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);
  const location = useLocation();
  const handleAddAddress = () => {
    if (isDesktop) {
      navigate(`${location.state?.oldLocation?.pathname || location.pathname}?modal=addaddress`);
    } else {
      navigate(`/${intl.locale}/addAddress/${action}`, {
        replace: true,
      });
    }
  };
  return (
    <div className={css.noAdd}>
      <img
        src={noImg}
        alt={<FormattedMessage id="addresslist_noaddress" defaultMessage="No address" />}
      />
      <h3>
        <FormattedMessage id="addresslist_noaddress" defaultMessage="No address" />
      </h3>
      <p>
        {' '}
        <FormattedMessage
          id="addressList_noAddress_desc"
          defaultMessage="Add address for one click checkout"
        />
      </p>

      <Button onClick={handleAddAddress}>
        <FormattedMessage id="addresslist_addnew" defaultMessage="Add Address" />
      </Button>
    </div>
  );
};

export default NoAddress;
